import { render, staticRenderFns } from "./RIClosing.vue?vue&type=template&id=9170a6c2&"
import script from "./RIClosing.vue?vue&type=script&lang=js&"
export * from "./RIClosing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports